// extracted by mini-css-extract-plugin
export default {"detailsButton":"TableItem_detailsButton__PYRBK","icon":"TableItem_icon__EOg1k","alignCenter":"TableItem_alignCenter__+t6-Q"};